import { Box, Badge as UCLBadge, View } from '@rbilabs/universal-components';

export const thumbnailSize = {
  width: '$17.5',
  height: '$13.5',
};

export const ItemThumbnailContainer = Box.withConfig({
  ...thumbnailSize,
  alignItems: 'center',
});

export const ThumbnailBox = View.withConfig({
  ...thumbnailSize,
  borderRadius: Styles.borderRadius,
  position: 'absolute',
  backgroundColor: Styles.color.grey.eleven,
  alignItems: 'center',
  shadow: 1,
  style: {
    shadowOpacity: 0.2,
    shadowRadius: 6,
  },
});

export const ThumbnailBehind = ThumbnailBox.withConfig({
  style: {
    shadowOpacity: 0.3,
    shadowRadius: 2,
  },
});

export const BadgeContainer = Box.withConfig({
  position: 'absolute',
  bottom: '$10',
  left: '$13.5',
  width: '$5',
  height: '$5',
});

export const Badge = UCLBadge.withConfig({
  _text: {
    fontFamily: 'heading',
    fontSize: 'xs',
  },
  width: '$5',
  height: '$5',
  style: {
    minWidth: 'auto',
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: 0,
    paddingBottom: 0,
  },
});
